import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { LeasingFormFields } from "web_myplann/Portfolio/Forms/LeasingForm/LeasingFormFields";
import { useCreateLeasingForm } from "web_myplann/Portfolio/Forms/LeasingForm/useCreateLeasingForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateLeasingForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateLeasingForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<LeasingFormFields
				control={form.control}
				collapseParams
				showRemainsToPay
			/>
		</PortfolioFormShell>
	);
};
